import { ApolloError } from "apollo-server-errors";
import { StatusCodes } from "http-status-codes";

/** A server error */
export default class ServerError extends ApolloError {
    constructor(public message: string, statusCode = StatusCodes.OK) {
        global.executions.addLine({className: "ServerError",functionName: "[constructor]",hierarchy: ["/backend/models/server-error.ts", "ServerError", "[constructor]"],fileName: "/backend/models/server-error.ts",childLine: 7,line: "        super('Server Error', 'ServerError', {"});
        super('Server Error', 'ServerError', {
            message,
            statusCode
        })
    }
}